import { createReducer, on } from '@ngrx/store';
import { Customer } from '@models/customer.model';
import {
  cannotCreateCustomer,
  cannotDeleteCustomer,
  cannotFetchCustomers,
  cannotFetchMe,
  cannotUpdateCustomer,
  cannotUpdateProfile,
  createCustomer,
  customerCreated,
  customerDeleted,
  customersFetched,
  customerUpdated,
  deleteCustomer,
  fetchCustomers,
  fetchMe,
  meFetched,
  profileUpdated,
  updateCustomer,
  updateProfile
} from '../actions/customer.actions';
import { SharedState } from './index';

export interface CustomerState extends SharedState {
  customers: Customer[];
  me: Customer | null;
}

export const initialCustomerState: CustomerState = {
  loaded: false,
  isLoading: false,
  error: '',
  customers: [],
  me: null,
}

export const customerReducer = createReducer(
  initialCustomerState,
  on(fetchCustomers, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(customersFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    customers: payload
  })),
  on(cannotFetchCustomers, (state, {error}) => ({...state, isLoading: false, loaded: false, error, customers: []})),
  on(updateCustomer, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(customerUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    customers: state.customers.map(g => g.id === payload.id ? payload : g)
  })),
  on(cannotUpdateCustomer, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(createCustomer, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(customerCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    customers: [...state.customers, payload]
  })),
  on(cannotCreateCustomer, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(deleteCustomer, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(customerDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    customers: state.customers.filter(customer => customer.id !== payload)
  })),
  on(cannotDeleteCustomer, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
  on(fetchMe, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(meFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    me: payload
  })),
  on(cannotFetchMe, (state, {error}) => ({...state, isLoading: false, loaded: false, error, me: null})),
  on(updateProfile, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(profileUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    me: payload
  })),
  on(cannotUpdateProfile, (state, {error}) => ({...state, isLoading: false, loaded: false, error})),
);
